<script setup lang="ts">

import Button from "@/components/UI/Button/Button.vue";
import {onMounted, ref} from "vue";
import TimeZoneInput from "@/components/FormInput/TimeZoneInput.vue";
import TimeZonePopup from "@/ts/Popup/TimeZonePopup";
import UserService from "@/ts/User/Service/UserService";

const emit = defineEmits(['create'])
const defaultTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const timezone = ref<string>(defaultTimeZone);
const isShowed = ref(false);
const popup = ref<HTMLDivElement>();
onMounted(() => {
  const instance = TimeZonePopup.getInstance();
  instance.addOnShowListener(async () => {
    isShowed.value = true
  })
  instance.init(isShowed, popup.value!);
})

const onChoice = async () => {
  await UserService.saveTimeZone(timezone.value);
  isShowed.value = false;
}
</script>

<template>
  <div ref="popup" class="popup-wrapper" :class="{show: isShowed}">
      <div class="timezone-popup">
        <div class="timezone-popup__content">
          <div class="timezone-popup__title">Выберите часовой пояс для корректной работы приложения</div>
          <div class="timezone-popup__description">Наше приложение использует ваш часовой пояс для корректной работы функций, отображения данных и уведомлений</div>
          <div class="input"><TimeZoneInput v-model="timezone"/></div>
          <div>
            <Button active activeColor="#6C7BB2" @click="onChoice">Выбрать</Button></div>
        </div>
      </div>
  </div>
</template>

<style scoped lang="scss">
.input{
  margin: 30px 0;
}
.popup{
  &-wrapper{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    background-color: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    visibility: hidden;
    opacity: 0;
    &.show {
      visibility: visible;
      opacity: 1;
      transition: opacity 0.3s;
    }
  }
}
.timezone-popup{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 20px;
  &__title{
    font-weight: 600;
    font-size: 20px;
    text-align: center;
    line-height: 23px;
  }
  &__description{
    margin-top: 10px;
    line-height: 16px;
    font-size: 14px;
    text-align: center;
  }
  &__content{
    background-color: #FFFFFF;
    padding: 30px 20px 20px 20px;
    border-radius: 30px;
    color: #363739;
    max-width: 340px;
  }
}
</style>
